
export enum COLLECTIONS {
  ADMIN = "admins",
  USER = "users",
  PURCHASED_CONTENTS = "purchased-contents",
  PURCHASES = "purchases",
  PAYOUTS = "payouts",
  LEARNING_LOGS = "learning-logs",
  CONTENTS = "contents",
  CONTENT_SECTIONS = "content-sections",
  CART = "carts",
  CART_ITEMS = "cart-items",
  PAYMENT_METHODS ="payment-methods",
};